import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const discounts = Loadable(() => import('../../containers/web/discounts'));
export default MapTo('vcg/components/soe-home/react/discounts')(discounts);
